import { Button, Typography } from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'

const RejectBtn = ({
  disabled,
  onClick
}: {
  disabled: boolean
  onClick: () => void
}) => {
  return (
    <Button
      size='large'
      color='error'
      startIcon={
        <CancelIcon
          sx={{
            color: !disabled ? 'error.main' : 'disabledBackground'
          }}
        />
      }
      onClick={onClick}
      disabled={disabled}
      sx={{
        marginLeft: '20px',
        backgroundColor: !disabled
          ? 'rgba(211, 47, 47, 0.08)'
          : 'disabledBackground',
        minWidth: '99px'
      }}>
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 700,
          color: !disabled ? 'error.main' : undefined
        }}>
        Reject
      </Typography>
    </Button>
  )
}

export default RejectBtn
